'use client';

import { c as _c } from "react/compiler-runtime";
import { faArrowRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useCachedUnitProgressSWR } from '~/app/actions/progress';
import RichTextHtml from '~/components/RichTextHtml';
import BlockTag from '~/components/blocks/BlockTag';
import { cn } from '~/lib/utils';
import { CourseUnit } from '~/payload-types';
import BookmarkAction from './interaction/BookmarkAction';
export default function UnitOverviewContent(t0) {
  const $ = _c(45);
  const {
    unit,
    modulePath,
    showWeiterButton: t1
  } = t0;
  const showWeiterButton = t1 === undefined ? true : t1;
  const params = useParams();
  let t2;
  if ($[0] !== modulePath) {
    t2 = modulePath.split("/").pop() || "";
    $[0] = modulePath;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const moduleId = t2;
  const t3 = params.courseId;
  const t4 = String(unit.id);
  let t5;
  if ($[2] !== moduleId || $[3] !== params.courseId || $[4] !== t4) {
    t5 = {
      courseId: t3,
      moduleId,
      unitId: t4,
      suspense: false
    };
    $[2] = moduleId;
    $[3] = params.courseId;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    data: progress
  } = useCachedUnitProgressSWR(t5);
  let t6;
  if ($[6] !== progress?.completedBlocks) {
    t6 = new Set((progress?.completedBlocks || []).map(_temp));
    $[6] = progress?.completedBlocks;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const completedBlockIds = t6;
  let t7;
  if ($[8] !== progress?.onceCompletedBlocks) {
    t7 = new Set((progress?.onceCompletedBlocks || []).map(_temp2));
    $[8] = progress?.onceCompletedBlocks;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onceCompletedBlockIds = t7;
  let t8;
  if ($[10] !== completedBlockIds || $[11] !== onceCompletedBlockIds) {
    t8 = blockIdentifier => {
      if (completedBlockIds.has(blockIdentifier)) {
        return "completed";
      }
      if (onceCompletedBlockIds.has(blockIdentifier)) {
        return "in-progress";
      }
      return "not-started";
    };
    $[10] = completedBlockIds;
    $[11] = onceCompletedBlockIds;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const getBlockProgressState = t8;
  let t9;
  if ($[13] !== getBlockProgressState || $[14] !== unit.components) {
    t9 = () => {
      const firstInProgressBlock = unit.components.find(block => getBlockProgressState(block.identifier) === "in-progress");
      if (firstInProgressBlock) {
        return firstInProgressBlock.identifier;
      }
      const firstNotStartedBlock = unit.components.find(block_0 => getBlockProgressState(block_0.identifier) === "not-started");
      if (firstNotStartedBlock) {
        return firstNotStartedBlock.identifier;
      }
      return unit.components[0]?.identifier;
    };
    $[13] = getBlockProgressState;
    $[14] = unit.components;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const getNextBlockIdentifier = t9;
  const t10 = unit.id;
  let t11;
  if ($[16] !== getNextBlockIdentifier) {
    t11 = getNextBlockIdentifier();
    $[16] = getNextBlockIdentifier;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const nextBlockHref = `${modulePath}/unit/${t10}/block/${t11}`;
  let t12;
  if ($[18] !== modulePath) {
    t12 = modulePath.split("/").slice(0, -2).join("/");
    $[18] = modulePath;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const backHref = t12;
  let t13;
  if ($[20] !== unit.description) {
    t13 = unit.description && <div className="w-full max-w-full overflow-hidden"><RichTextHtml data={unit.description} /></div>;
    $[20] = unit.description;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== getBlockProgressState || $[23] !== moduleId || $[24] !== modulePath || $[25] !== unit.components || $[26] !== unit.id) {
    let t15;
    if ($[28] !== getBlockProgressState || $[29] !== moduleId || $[30] !== modulePath || $[31] !== unit.id) {
      t15 = block_1 => {
        const progressState = getBlockProgressState(block_1.identifier);
        const showTag = block_1.blockType !== "olat-link" && Boolean(block_1.tag);
        return <Link href={`${modulePath}/unit/${unit.id}/block/${block_1.identifier}`} key={block_1.id} className="w-full"><div className={cn("w-full aspect-square p-2 bg-white border border-gray-200 shadow-[0px_0px_10px_0px_rgba(0,_0,_0,_0.1)] rounded-lg transition-all hover:border-t-4 hover:border-primary-100", progressState === "completed" && "bg-uzh-lightgreen-20")}><div className="flex flex-col justify-between w-full h-full"><div className="w-full min-h-0 overflow-hidden"><div className="flex items-start justify-between w-full gap-1"><div className="flex flex-col flex-1 min-w-0 gap-1"><div className="text-xs font-medium sm:text-sm line-clamp-3">{block_1.title}</div>{showTag && <BlockTag tag={block_1.tag} className="h-4 w-fit rounded px-1 py-0 text-[10px] leading-3" />}</div><div className="flex-shrink-0"><BookmarkAction moduleId_={moduleId} unitId_={unit.id.toString()} blockIdentifier={block_1.identifier} /></div></div></div><div className="flex items-center justify-between w-full pt-2 mt-auto">{progressState === "completed" ? <FontAwesomeIcon icon={faCircleCheck} className="text-xs text-uzh-lightgreen sm:text-sm" /> : <FontAwesomeIcon icon={faArrowRight} className="text-xs sm:text-sm" />}<div className="text-xs sm:text-sm whitespace-nowrap">{block_1.time} min</div></div></div></div></Link>;
      };
      $[28] = getBlockProgressState;
      $[29] = moduleId;
      $[30] = modulePath;
      $[31] = unit.id;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    t14 = unit.components.map(t15);
    $[22] = getBlockProgressState;
    $[23] = moduleId;
    $[24] = modulePath;
    $[25] = unit.components;
    $[26] = unit.id;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(150px,1fr))] min-[960px]:grid-cols-[repeat(auto-fit,minmax(150px,160px))] min-[960px]:justify-start gap-2 sm:gap-3">{t14}</div>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t15) {
    t16 = <div className="flex-1 min-h-0 space-y-3 overflow-x-hidden overflow-y-auto pl-4 sm:space-y-4 sm:pl-6 in-iframe:flex-none in-iframe:min-h-fit">{t13}{t15}</div>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== backHref || $[39] !== nextBlockHref || $[40] !== showWeiterButton) {
    t17 = showWeiterButton && <div className="pt-4 pb-2 mt-4 border-t sm:pb-6"><div className="flex justify-between"><Link href={backHref} className="inline-block bg-gray-300 text-gray-700 px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg hover:bg-gray-400 transition-colors font-medium shadow-md">Zurück</Link><Link href={nextBlockHref} className="inline-block bg-primary-100 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg hover:bg-primary-80 transition-colors font-medium shadow-md">Weiter</Link></div></div>;
    $[38] = backHref;
    $[39] = nextBlockHref;
    $[40] = showWeiterButton;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t16 || $[43] !== t17) {
    t18 = <div className="flex flex-col w-full h-full max-w-full in-iframe:h-auto">{t16}{t17}</div>;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
}
function _temp2(b_0) {
  return b_0.blockIdentifier;
}
function _temp(b) {
  return b.blockIdentifier;
}